import styled from "styled-components";

export const AboutContainer = styled.div`
  background: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    /* url("https://wallpaperaccess.com/full/5952137.jpg"); */
      url("https://images.hdqwalls.com/download/dark-blue-green-gradient-4k-i4-1366x768.jpg");
  height: 100%;
  background-position: center;
  background-size: cover;
`;
